import UsersIcon from "@/assets/icons/users.svg";
import { useMentionCard } from "@/containers/MentionCard/context";
import { useI18n } from "@/contexts/i18nContext";
import { round } from "@/utils";
import Highlight from "@components/Highlight";
import Tooltip from "@components/Tooltip";

const Reach = () => {
  const {
    channel: { channel_type },
    episode: { reach, reach_date, reach_description, reach_source_type },
  } = useMentionCard();
  const { formatNumber } = useI18n();

  if (reach && (channel_type !== "youtube" || reach_source_type !== "none")) {
    const inner = (
      <Highlight
        icon={UsersIcon}
        data-testid="reach"
        label={formatNumber(round(reach))}
      />
    );
    return reach_description ? (
      <Tooltip content={`${reach_description} ${reach_date || ""}`}>
        <a
          href={L.HELP_ARTICLE_REACH}
          target="_blank"
          rel="noreferrer"
          data-testid="reach-help-article-link"
        >
          {inner}
        </a>
      </Tooltip>
    ) : (
      inner
    );
  } else {
    return null;
  }
};

export default Reach;
